import React from "react";
import { Anchor, Box, Text, Image, ResponsiveContext } from "grommet";
import { IconSvg } from "../IconSvg";
import { Partners } from "./Partners";
import { SocialMedia } from "../SocialMedia";
import mangazeya from "../../Icons/Footer/mangazeya.png";
import { NameSpace } from "../../const/namespace";
export var Footer = function Footer(_ref) {
  var logo = _ref.logo;
  var date = new Date().getFullYear();
  return /*#__PURE__*/ React.createElement(
    Box,
    null,
    /*#__PURE__*/ React.createElement(
      Box,
      {
        direction: "row",
        margin: {
          top: "large",
        },
        border: "top",
        pad: {
          vertical: "2vw",
        },
        gap: "medium",
        justify: "between",
      },
      /*#__PURE__*/ React.createElement(
        Box,
        {
          direction: "column",
          justify: "between",
          gap: "medium",
        },
        /*#__PURE__*/ React.createElement(Partners, null),
        /*#__PURE__*/ React.createElement(ResponsiveContext.Consumer, null, function (size) {
          return /*#__PURE__*/ React.createElement(
            Box,
            {
              direction:
                size !== NameSpace.mobile && size !== NameSpace.miniMobile ? "row" : "column",
              gap: size !== NameSpace.mobile && size !== NameSpace.miniMobile ? "20px" : "10px",
              align:
                size !== NameSpace.mobile && size !== NameSpace.miniMobile ? "center" : "start",
            },
            /*#__PURE__*/ React.createElement(
              Box,
              {
                alignSelf: "start",
              },
              logo
            ),
            /*#__PURE__*/ React.createElement(
              Box,
              null,
              /*#__PURE__*/ React.createElement(
                Anchor,
                {
                  href: "https://mangazeya.ru/",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  style: {
                    padding: "0",
                  },
                },
                /*#__PURE__*/ React.createElement(Image, {
                  src: mangazeya,
                  width: "150px",
                })
              )
            )
          );
        })
      ),
      /*#__PURE__*/ React.createElement(
        Box,
        {
          gap: "14px",
          align: "end",
        },
        /*#__PURE__*/ React.createElement(SocialMedia, null),
        /*#__PURE__*/ React.createElement(
          Box,
          {
            flex: true,
            direction: "column",
            gap: "xxsmall",
            align: "end",
            style: {
              textAlign: "end",
            },
          },
          /*#__PURE__*/ React.createElement(
            Text,
            {
              size: "xsmall",
              color: "#333333",
            },
            "\u0412\u0441\u0435 \u043F\u0440\u0430\u0432\u0430 \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u044B \xA9 ",
            date
          ),
          /*#__PURE__*/ React.createElement(
            Text,
            {
              size: "xsmall",
              color: "#333333",
            },
            "\u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u044F \u0442\u0440\u0438\u0430\u0442\u043B\u043E\u043D\u0430 \u0433\u043E\u0440\u043E\u0434\u0430 \u041C\u043E\u0441\u043A\u0432\u044B"
          ),
          /*#__PURE__*/ React.createElement(
            Anchor,
            {
              href: "mailto:" + "moskva@rustriathlon.ru",
              style: {
                fontWeight: "bolder",
                fontSize: "12px",
              },
              color: "#DB4C4C",
            },
            "moskva@rustriathlon.ru"
          ),
          /*#__PURE__*/ React.createElement(
            Box,
            {
              width: "80px",
              margin: {
                top: "small",
              },
            },
            /*#__PURE__*/ React.createElement(IconSvg, {
              src: "marketLogo",
              width: "80px",
              height: "26px",
            })
          )
        )
      )
    )
  );
};
